/**
 * @desc 获取母仓列表
 */
const URL = "/rantion-fulfilment";
import http, { updateResponse } from "@/http";
export function request(
  params: API.fulfilment.warehouseFacadeImpl.getWarehouseMasterList.Params,
  options?: any,
) {
  return updateResponse(
    http(URL + `/warehouse/rootList`, {
      method: "POST",
      params,

      ...options,
    }),
  );
}
